import { SelectionChangedEvent } from "ag-grid-community";
import _ from "lodash";
import { INITIAL_GENERAL_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF, transferRowData } from "presentation/constant/GeneralProposal/GeneralProposalTariffItemTierColumnDefinition";
import { useGeneralProposalDetailVM } from "presentation/hook/GeneralProposal/useGeneralProposalDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useGeneralProposalDetailTracked } from "presentation/store/GeneralProposal/GeneralProposalDetailProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GeneralProposalHeaderFormPanel } from "../Left/GeneralProposalHeaderFormPanel";

const GeneralProposalDetailTablePanel: React.FC = () => {
    const [generalProposalDetailState] = useGeneralProposalDetailTracked();
    const generalProposalDetailVM = useGeneralProposalDetailVM();
    const { generalProposalItemTierList, currentTariffItemTier, generalProposalItemIsList, tariffItemTierSelectedRows, isShowEditPanel } = generalProposalDetailState;
    let gridRef: any = useRef();
    const messageBarVM = useMessageBarVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate, allowUpdate, allowDelete } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        generalProposalDetailVM.updateSelectedTariffItemTierRows(selectedRows);

    }, [generalProposalDetailVM])


    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        //const columnDefs = (INITIAL_GENERAL_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF?.slice());

        if (!generalProposalDetailState.tariffItemTierSelectedRows ||
            generalProposalDetailState.tariffItemTierSelectedRows.length <= 0) {
            //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
            if (!onTableSelectionClicked) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
        }
    })

    const handleAdd = useCallback(() => {
        if (!_.isEmpty(generalProposalItemTierList) && generalProposalItemTierList.length === 1 && !_.isEmpty(generalProposalItemIsList)) {
            messageBarVM.showError("Intensive surcharge does not support multiple charge tier.");
            return;
        }
        generalProposalDetailVM.onAddTier();
    }, [messageBarVM, generalProposalItemTierList, generalProposalItemIsList, generalProposalDetailVM]);

    const handleEdit = useCallback(() => {
        if (currentTariffItemTier?.tierNo == null) {
            messageBarVM.showError("Please select a Tier record.");
            return;
        }
        generalProposalDetailVM.onTariffItemTierEidtClick();
    }, [currentTariffItemTier?.tierNo, messageBarVM, generalProposalDetailVM]);


    const handleDelete = useCallback(() => {

        if (_.isEmpty(tariffItemTierSelectedRows)) {
            messageBarVM.showError("Please select a Tier record.");
            return;
        }

        if (_.isEmpty(generalProposalItemTierList) || generalProposalItemTierList.length === 1
            || generalProposalItemTierList.length === tariffItemTierSelectedRows.length) {
            messageBarVM.showError('At least one tier is required.')
            return;
        }
        generalProposalDetailVM.onDeleteTier();
    }, [generalProposalDetailVM, generalProposalItemTierList, messageBarVM, tariffItemTierSelectedRows])

    const memoBtns = useMemo(() => {

        const hdrBtns = [];
        if (!isShowEditPanel && allowUpdate) {
            hdrBtns.push({
                id: 'onEditButton',
                icon: 'Icon-pen',
                title: 'Edit'
            })
        }

        if (!isShowEditPanel && allowDelete) {
            hdrBtns.push({
                id: 'onDeleteButton',
                icon: 'Icon-trash',
                title: 'Delete'
            })
        }

        return hdrBtns
    }, [allowDelete, allowUpdate, isShowEditPanel])


    const memoGeneralProposalTariffItemTierTable = useMemo(() => {

        return (
            <NbisTable
                id='general-proposal-detail-table'
                isNewColumnSetting={true}
                columns={INITIAL_GENERAL_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF?.slice()}
                data={transferRowData(generalProposalItemTierList ?? [])}
                headerActionButtons={memoBtns}
                onEditButton={handleEdit}
                onDeleteButton={handleDelete}
                // onCloseButton={handleClose}
                //onTickButton={handleSave}
                showPaginator={false}
                showAddIcon={allowCreate && !isShowEditPanel}
                onAddClick={handleAdd}
                showUploadIcon={false}
                showReloadIcon={false}
                showDeleteButton={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 350px)"
                ref={gridRef}
                showPivotMode={false}
            />
        );
    }, [generalProposalItemTierList, memoBtns, handleEdit, handleDelete, allowCreate, isShowEditPanel, handleAdd, handleSelectionChange])

    return <><div className="main-comp-wrapper">
        <GeneralProposalHeaderFormPanel />
        <div style={{ width: '100%', height: '100%', maxHeight: '85%' }}>
            <TableWrapper>
                {memoGeneralProposalTariffItemTierTable}
            </TableWrapper>
        </div>
    </div></>;
}

export default memo(GeneralProposalDetailTablePanel);
